import React, { useState } from 'react';
import queryString from 'query-string';
import { toaster } from 'evergreen-ui';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import PageHeader from 'components/shared/PageHeader';
import HospitalsList, {
  LIST_HOSPITALS_BY_ORG
} from 'components/admin/HospitalsList';
import DeleteDialog from 'components/shared/DeleteDialog';
import {
  withDefaultPageInfo,
  parseFilters,
  onFilterUpdate,
  onPageInfoUpdate
} from 'lib/pagination';

const DELETE_HOSPITAL = gql`
  mutation DeleteHospitalForOrg($input: DeleteHospitalInput!) {
    result: deleteHospital(input: $input) {
      hospital {
        id
      }
      errors {
        message
      }
    }
  }
`;

export default ({ history, organization }: any) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const qs = queryString.parse(history.location.search);
  const pageInfo = withDefaultPageInfo(qs.page);
  const filters = parseFilters(qs.filters);

  const variables = {
    ...pageInfo,
    filters: { ...filters, publishedState: 'DRAFT' },
    organizationId: organization.id
  };

  const refetchQuery = {
    variables,
    query: LIST_HOSPITALS_BY_ORG
  };

  const [deleteHospital, { loading: isDeleteLoading }] = useMutation(
    DELETE_HOSPITAL,
    {
      refetchQueries: [refetchQuery],
      onCompleted: ({ result }: any) => {
        if (result.hospital) {
          toaster.success('Hospital has been successfully deleted');
        } else {
          toaster.danger('Could not delete hospital, please try again');
        }
        setShowDeleteDialog(false);
      }
    }
  );

  return (
    <>
      <PageHeader
        title="Manage hospitals"
        subtitle="Viewing all hospitals owned by this organization."
      />

      <HospitalsList
        organizationId={organization.id}
        filters={filters}
        variables={variables}
        onFilterUpdate={onFilterUpdate(history)}
        onPageInfoUpdate={onPageInfoUpdate(history, filters)}
        onDeleteClick={(hospital: any) => setShowDeleteDialog(hospital)}
        onEditClick={(hospital: any) => {
          history.push(`/orgs/${organization.slug}/hospitals/${hospital.id}`);
        }}
      />

      <DeleteDialog
        isShown={showDeleteDialog !== false}
        onCloseComplete={() => setShowDeleteDialog(false)}
        onConfirm={() =>
          deleteHospital({
            // @ts-expect-error TS(2339): Property 'id' does not exist on type 'boolean'.
            variables: { input: { id: showDeleteDialog.id } }
          })
        }
        isLoading={isDeleteLoading}
      />
    </>
  );
};
